import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { CircularProgress, IconButton, Stack, Typography, useTheme } from '@mui/material';

import { generalPredefinedPromptsTexts } from '../../../constants';
import { useDeleteGeneralPredefinedPrompt } from '../../../services/queries';

interface PromptSectionTitleProps {
    promptIndex: number;
    groupId?: string;
    promptId?: string;
    deleteDynamicField: (promptIndex: number) => void;
}

export const PromptSectionTitle = ({
    promptIndex,
    groupId,
    promptId,
    deleteDynamicField,
}: PromptSectionTitleProps) => {
    const theme = useTheme();
    const { mutate: deleteGeneralPredefinedPrompt, isPending: isDeleting } =
        useDeleteGeneralPredefinedPrompt();

    const promptNumber = promptIndex + 1;
    const promptLabel = generalPredefinedPromptsTexts.promptLabel + promptNumber;

    const isExistingPrompt = groupId && promptId;

    const handleClick = isExistingPrompt
        ? () => deleteGeneralPredefinedPrompt({ groupId, promptId })
        : () => deleteDynamicField(promptIndex);

    return (
        <Stack direction='row' alignItems='center' gap={1}>
            <Typography variant='subtitle2'>{promptLabel}</Typography>
            <IconButton onClick={handleClick} disabled={isDeleting}>
                <DeleteRoundedIcon sx={{ color: theme.palette.customColors.orange }} />
            </IconButton>
            {isDeleting && (
                <CircularProgress size={24} sx={{ color: theme.palette.customColors.purple }} />
            )}
        </Stack>
    );
};
